import type { SingleRecordResponse } from '@stakeholderlabs/types'
import { useApiGet } from '~/composables/api/useBaseFetch'
import type { Redirect } from '~/types'

export const useRedirectApi = () => {
  const view = (url: string) => {
    return useApiGet<SingleRecordResponse<Redirect.Model>>(`/redirects/`, {
      params: {
        url,
      },
    })
  }

  return { view }
}
